var AWS = require('aws-sdk');
const { loadEnv } = require('./secrets');
AWS.config.region = "us-east-1";
let envValues = process.env;

async function getAsyncEnvVals() {
    // Load env from Secrets Manager
    await loadEnv();
    // Assign BOBTAIL_ENV_NAME so that we don't call getEnvironmentName multiple times
    process.env['BOBTAIL_ENV_NAME'] = (process.env.BOBTAIL_PROFILE ? `${process.env.BOBTAIL_PROFILE}_${process.env.ENV_NAME}` : false) || process.env.ENV_NAME;
    console.log('Env name:', process.env['BOBTAIL_ENV_NAME']);
    // Decode BOBTAIL_SSH_FILE_BASE64 only if not already done
    if (!process.env.BOBTAIL_SSH_FILE) {
      let buff = Buffer.from(process.env['BOBTAIL_SSH_FILE_BASE64'], 'base64');
      process.env['BOBTAIL_SSH_FILE'] = buff.toString('ascii');
    }
    // Store all env variables globally to work with BOBTAIL_ENV
    envValues = process.env;
    return Promise.resolve()
}
function BOBTAIL_ENV(variable) {
    if (!envValues[variable]) {
        console.warn(`Could not find env value for variable ${variable}`);
        return undefined;
    }
    return envValues[variable];
}

function s3URL(doc, encodeKey = false){
  const key = encodeKey ? encodeURIComponent(doc.key) : doc.key;
  return `https://${doc.container}.s3.amazonaws.com/${key}`
}

function s3URLParser(urlString, decodeKey = false){
  const url = new URL(urlString);

  // computes S3 virtual style format
  let key = url.pathname.substring(1);
  let bucket = url.hostname.replace(".s3.amazonaws.com","");
  if (bucket === url.hostname) {
    // this means the bucket name is into path format, so we need to extract bucket name from the pathname
    const splitPath = key.split('/');
    bucket = splitPath.shift()
    key = splitPath.join('/');
  }
  if (decodeKey){
    key = decodeURIComponent(key);
  }
  return { bucket, key }
}

module.exports = {
    getAsyncEnvVals,
    BOBTAIL_ENV,
    s3URL,
    s3URLParser
}
